import * as yup from "yup";
import { BookingErrorsDto } from "../../../../Api/Model/BookingSteps/BookingErrorsDto.csharp";

export const PhoneNumberValidator = (errors: BookingErrorsDto) =>
    yup.object().shape({
        mobileNumber: yup
            .string()
            .test("required", errors.fieldIsRequired, (value) => !!value)
            .test(
                "type",
                errors.telephone,
                (value) => value != undefined && !isNaN(Number(value))
            )
            .test(
                "length",
                errors.telephone,
                (value) => value != undefined && value.length >= 8
            ),
    });
